<template>
	<div>
		<label class="cp-label mt-1" v-if="data.description && data.description !== ''"
			>{{ data.description }} <font-awesome-icon v-if="data.selector" class="cp-info text-info cursor-pointer fs-6" :title="data.selector" :icon="['fas', 'info']"
		/></label>
		<label class="cp-label" v-else
			>{{ generateLabel(data.name) }} <font-awesome-icon v-if="data.selector" class="cp-info text-info cursor-pointer" :title="data.selector" :icon="['fas', 'info']"
		/></label>
		<input
			v-if="data.name.toLowerCase().includes('count') || data.name.toLowerCase().includes('number')"
			type="number"
			v-model="data.value"
			class="form-control form-control-sm"
			min="0"
			@change="updatePreview()"
		/>

		<Editor
			v-else-if="data.name.toLowerCase().includes('_text') || data.name == 'TEXT'"
			:id="data.name + Date.now() + index"
			v-model="data.value"
			:init="editorSettings"
			@input="updatePreview()"
		/>

		<input
			v-else-if="data.name.toLowerCase().includes('color22')"
			type="color"
			v-model="data.value"
			class="form-control form-control-sm form-control-color w-100"
			title="Choose your color"
			@input="updatePreview()"
		/>

		<ColorChooser v-else-if="data.name.toLowerCase().includes('color')" v-on:change="updatePreview()" :data="data" v-model="data.value" :themeOptions="themeOptions" />

		<SizeChooser
			v-else-if="
				data.name.toLowerCase().includes('_size') ||
					data.name.toLowerCase().includes('-size') ||
					data.code.toLowerCase().includes('_size') ||
					data.name.toLowerCase().includes('-width') ||
					data.code.toLowerCase().includes('padding-right') ||
					data.code.toLowerCase().includes('padding-left') ||
					data.code.toLowerCase().includes('padding-top') ||
					data.code.toLowerCase().includes('padding-bottom') ||
					data.code.toLowerCase().includes('margin-right') ||
					data.code.toLowerCase().includes('margin-left') ||
					data.code.toLowerCase().includes('margin-top') ||
					data.code.toLowerCase().includes('margin-bottom')
			"
			v-on:change="updatePreview()"
			:data="data"
			v-model="data.value"
		/>

		<select
			v-else-if="data.code.toLowerCase().includes('justify-content') || data.code.toLowerCase().includes('align-items')"
			v-model="data.value"
			class="form-select"
			@change="updatePreview()"
		>
			<option value="unset">Unset</option>
			<option value="flex-start">Left (Top if Vertical)</option>
			<option value="center">Center</option>
			<option value="flex-end">Right (Bottom if Vertical)</option>
		</select>

		<select v-else-if="data.name.toLowerCase().includes('text-decoration')" v-model="data.value" class="form-select" @change="updatePreview()">
			<option value="">Default</option>
			<option value="none">None</option>
			<option value="underline">Underline</option>
			<option value="line-through">Line through</option>
			<option value="overline">Overline</option>
			<option value="underline overline">Underline Overline</option>
		</select>

		<select v-else-if="data.name.toLowerCase().includes('font-weight')" v-model="data.value" class="form-select form-select-sm" @change="updatePreview()">
			<option value="">None</option>
			<option value="100">Thin (100)</option>
			<option value="200">Extra Light (200)</option>
			<option value="300">Light (300)</option>
			<option value="400">Normal (400)</option>
			<option value="500">Medium (500)</option>
			<option value="600">Semi Bold (600)</option>
			<option value="700">Bold (700)</option>
			<option value="800">Extra Bold (800)</option>
			<option value="900">Black (900)</option>
		</select>

		<div v-else-if="data.name.toLowerCase().includes('desktop_css')">
			<codemirror
				:options="{
					tabSize: 2,
				}"
				v-model="data.value"
			></codemirror>
		</div>

		<div v-else-if="data.name.toLowerCase().includes('mobile_css')">
			<codemirror
				:options="{
					tabSize: 2,
				}"
				v-model="data.value"
			></codemirror>
		</div>

		<div v-else-if="data.name.toLowerCase().includes('tablet_css')">
			<codemirror
				:options="{
					tabSize: 2,
				}"
				v-model="data.value"
			></codemirror>
		</div>

		<div v-else-if="data.name.toLowerCase().includes('header_script')">
			<codemirror
				:options="{
					tabSize: 2,
				}"
				v-model="data.value"
			></codemirror>
		</div>

		<div v-else-if="data.name.toLowerCase().includes('footer_script')">
			<codemirror
				:options="{
					tabSize: 2,
				}"
				v-model="data.value"
			></codemirror>
		</div>

		<!-- <select
			v-else-if="data.name.toLowerCase().includes('font-family') || data.code.includes('_FONT')"
			v-model="data.value"
			class="form-select form-select-sm"
			@change="updatePreview()"
		>
			<option value="">Default</option>
			<option v-for="(font, i) in googleFonts" :value="font" :key="'font' + i">{{ font }}</option>
		</select> -->

		<select v-else-if="data.code.toLowerCase().includes('logo_position')" v-model="data.value" class="form-select form-select-sm" @change="updatePreview()">
			<option value="">Hide</option>
			<option value="top">Top</option>
			<option value="bottom">Bottom</option>
			<option value="left">Left</option>
			<option value="right">Right</option>
		</select>

		<select v-else-if="/^\{#display(_\d+)?#\}$/i.test(data.code)" v-model="data.value" class="form-select form-select-sm" @change="updatePreview()">
			<option value="block">Show</option>
			<option value="none">Hide</option>
		</select>

		<div v-else-if="data.name.toLowerCase().includes('font-family') || data.code.includes('_FONT')" class="cp-font-native-wrap">
			<input
				type="text"
				class="form-control form-control-sm cp-font-native-select"
				:list="fontListId()"
				v-model="data.value"
				@input="updatePreview()"
				@change="updatePreview()"
				placeholder="Select font..."
			/>
			<datalist :id="fontListId()">
				<option v-for="(font, i) in googleFonts" :value="font" :key="'font-native-' + i">{{ font }}</option>
			</datalist>
		</div>

		<input v-else-if="data.name.toLowerCase().includes('data_page_id_')" type="hidden" v-model="data.value" />
		<DataChooser v-else-if="data.name.toLowerCase().includes('data_page_id')" v-on:change="updatePreview()" :data="data" v-model="data.value" />

		<BusinessCategoryChooser
			v-else-if="data.code.toLowerCase().includes('category_id') || data.name.toLowerCase().includes('category_id')"
			v-on:change="updatePreview()"
			v-model="data.value"
		/>

		<div v-else-if="data.name.toLowerCase().includes('_array')" :key="data.name + itemKey">
			<div class="d-flex">
				<button @click="toggleArrayItems(data)" class="btn btn-sm btn-primary">
					<template v-if="data.displayItems">Hide Items</template>
					<template v-else>Show Items</template>
				</button>
				<button @click="reset()" class="btn btn-sm btn-primary ms-auto">
					<template>Reset</template>
				</button>
			</div>
			<draggable v-model="data.value" @change="updateItemsOrder()">
				<div v-if="data.name.includes('_DATA_SELECT_ARRAY')">
					<div class="card cp-item-card px-1 py-2 mt-3" :class="{ 'd-none': !data.displayItems }" v-for="(item, i) in data.value" :key="i">
						<button
							class="btn btn-danger btn-sm cp-item-remove-btn"
							@click="removeItem(i)"
							v-if="i > 0"
						>
							x
						</button>
						<div class="data-select-array">
							<div class="data-select-item" v-for="(attribute, j) in item" :key="j">
								<div v-if="attribute.name == 'TITLE' || attribute.name == 'NAME'">
									<div class="heading text-center bg-primary text-white fw-bold rounded" style="font-size:12px">
										{{ data.name.replace('_DATA_SELECT_ARRAY', '').replace('_', ' ') }}
									</div>
									<div v-if="attribute.value" class="title text-center mt-2">
										{{ attribute.value }}
									</div>
									<div v-else class="title">
										No item selected
									</div>
								</div>
							</div>
						</div>
						<button class="btn btn-primary btn-sm mt-2" @click="openDataChooseModal(data.name.replace('_DATA_SELECT_ARRAY', ''), item)">
							<font-awesome-icon :icon="['fas', 'fingerprint']" class="me-1" /> Select Item
						</button>
					</div>
				</div>
				<div v-else>
					<div v-if="data.displayItems">
						<div class="card cp-item-card px-1 py-2 mt-3" v-for="(item, i) in data.value" :key="i">
							<button
								class="btn btn-danger btn-sm cp-item-remove-btn"
								@click="removeItem(i)"
								v-if="i > 0"
							>
								x
							</button>
							<div v-for="(attribute, j) in item" :key="j">
								<CustomizerProperty
									:data="attribute"
									:index="j"
									:googleFonts="googleFonts"
									:type="'homepage'"
									:sectionIndex="sectionIndex"
									v-on:updatePreview="updatePreview($event)"
									v-on:showMediaLibraryModal="showMediaLibraryModal($event)"
								/>
							</div>
						</div>
					</div>
				</div>
			</draggable>
			<button @click="addItem()" class="bnt btn-primary btn-sm w-100 mt-2" :class="{ 'd-none': !data.displayItems }">
				+
			</button>
		</div>

		<div v-else-if="data.name.toLowerCase().includes('_flag') || data.code.toLowerCase().includes('_flag')" class="form-check form-switch mt-2">
			<input class="form-check-input" @change="updatePreview()" type="checkbox" v-model="data.value" />
		</div>

		<ImageChooser
			v-else-if="
				data.name.toLowerCase().includes('picture') ||
					data.name.toLowerCase().includes('_img') ||
					data.name.toLowerCase().includes('_image') ||
					data.code.toLowerCase().includes('_image')
			"
			v-on:change="updatePreview()"
			:data="data"
			v-model="data.value"
			v-on:showMediaLibraryModal="showMediaLibraryModal($event)"
		/>
		<div v-else-if="data.code.toLowerCase().includes('figma_variables')">
			<textarea class="form-control" v-model="data.value" @change="updatePreview()"></textarea>
			<button type="button" class="btn btn-sm btn-primary w-100 mt-1" @click="$emit('showFigmaAiModal', data)">
				<font-awesome-icon :icon="['fas', 'magic']" class="me-1" /> AI Assistant
			</button>
		</div>
		<input v-else type="text" v-model="data.value" class="form-control form-control-sm" @change="updatePreview()" />

		<!-- <p class="p-0 m-0 text-end" style="font-size:12px;font-weight:bold" v-if="data.selector">
			<code>{{ data.selector }}</code>
		</p> -->
	</div>
</template>

<script>
import draggable from 'vuedraggable'
import ImageChooser from '@/components/juniper/customizer/choosers/ImageChooser'
import ColorChooser from '@/components/juniper/customizer/choosers/ColorChooser'
import SizeChooser from '@/components/juniper/customizer/choosers/SizeChooser'
import DataChooser from '@/components/juniper/customizer/choosers/DataChooser'
import BusinessCategoryChooser from '@/components/juniper/business-directory/BusinessCategoryChooser'
import Editor from '@tinymce/tinymce-vue'
export default {
	name: 'CustomizerProperty',
	components: { Editor, draggable, ImageChooser, ColorChooser, SizeChooser, DataChooser, BusinessCategoryChooser },
	props: ['data', 'index', 'googleFonts', 'type', 'sectionIndex', 'themeOptions'],
	data() {
		return {
			editorSettings: {
				menubar: false,
				plugins: 'link code lists',
				toolbar1: 'fontsizeselect forecolor formatselect bold italic underline bullist alignleft aligncenter alignright link removeformat code',
				valid_elements: '*[*]',
				fontsize_formats: '8px 10px 12px 14px 16px 18px 20px 24px 28px 32px 36px 48px 60px 72px 96px',
			},
			dataSelectItem: {},
			displayItemsFlag: '',
			itemKey: 0,
			defaultValue: null,
		}
	},
	created() {
		if (this.data.defaultValue) {
			this.defaultValue = JSON.parse(JSON.stringify(this.data.defaultValue))
		}
	},
	watch: {
		data: {
			handler(newVal) {
				if (newVal.defaultValue) {
					this.defaultValue = JSON.parse(JSON.stringify(newVal.defaultValue))
				}
			},
			deep: true,
		},
	},
	methods: {
		// Generate label
		generateLabel(name) {
			name = name.replaceAll('_', ' ')
			name = name.replaceAll('-', ' ')
			name = name.toLowerCase()
			name = name.replace('css', '')
			name = name.charAt(0).toUpperCase() + name.slice(1)
			name = name.replace('array', 'items')
			return name
		},
		updatePreview() {
			this.$emit('updatePreview', { type: this.type, sectionIndex: this.sectionIndex })
		},

		/**
		 * Add item to value array
		 */
		addItem() {
			let newValue = JSON.parse(JSON.stringify(this.data.value[0]))
			this.data.value.push(newValue)
			this.updatePreview()
		},

		/**
		 * Remove item from value array
		 */
		removeItem(i) {
			this.data.value.splice(i, 1)
			this.updatePreview()
		},

		/**
		 * Reset value array to default value
		 */
		reset() {
			this.data.value = this.defaultValue
			this.updatePreview()
		},

		/**
		 * Update Items order
		 * Function updates order of items in value array
		 */
		updateItemsOrder() {
			const newList = [...this.data.value].map((item, index) => {
				const newSort = index + 1
				// also add in a new property called has changed if you want to style them / send an api call
				item.hasChanged = item.order !== newSort
				if (item.hasChanged) {
					item.order = newSort
				}
				return item
			})
			this.data.value = newList
			this.updatePreview()
		},

		showMediaLibraryModal(e) {
			this.$emit('showMediaLibraryModal', e)
		},

		openDataChooseModal(type, item) {
			let e = {
				type: type,
				item: item,
				sectionIndex: this.sectionIndex,
				sectionType: this.type,
			}
			this.dataSelectItem = item
			this.$emit('showDataSelectModal', e)
		},

		toggleArrayItems(data) {
			if (data.displayItems && data.displayItems == true) {
				data.displayItems = false
			} else {
				data.displayItems = true
			}
			this.itemKey += 1
		},
		fontListId() {
			const raw = `${this.data.code || this.data.name || 'font'}-${this.index}`
			return `font-list-${raw.toLowerCase().replace(/[^a-z0-9-]/g, '-')}`
		},
	},
	emits: ['showMediaLibraryModal', 'updatePreview', 'showDataSelectModal', 'showFigmaAiModal'],
}
</script>
<style>
.cp-label {
	font-size: 12px;
	font-weight: 600;
	color: #1f2937;
	margin-bottom: 4px;
}

.cp-info {
	font-size: 12px;
	opacity: 0.9;
}

.cp-font-select {
	margin-left: 0 !important;
}

.cp-font-native-wrap {
	position: relative;
}

.cp-font-native-select {
	background-color: #e6ebf0 !important;
	border: 1px solid #cbd5e1 !important;
	border-radius: 8px !important;
	box-shadow: none !important;
	font-size: 12px;
	color: #334155;
	padding-right: 28px;
}

.cp-font-native-select:focus {
	box-shadow: none !important;
	border-color: #94a3b8 !important;
}

.cp-font-select.multiselect {
	min-height: 32px;
}

.cp-font-select .multiselect__tags {
	min-height: 32px;
	padding: 4px 34px 4px 10px;
	border: 1px solid #cbd5e1;
	border-radius: 8px;
	background: #e6ebf0;
	font-size: 12px;
	box-shadow: none !important;
}

.cp-font-select .multiselect__single {
	margin: 0;
	padding: 0;
	background: transparent;
	color: #1f2937;
	line-height: 22px;
	font-size: 12px;
}

.cp-font-select .multiselect__select {
	height: 30px;
	width: 30px;
}

.cp-font-select .multiselect__select::before {
	top: 55%;
	border-color: #475569 transparent transparent;
}

.cp-font-select.multiselect--active .multiselect__tags {
	border-color: #94a3b8;
	box-shadow: none !important;
}

.cp-font-select .multiselect__content-wrapper {
	border: 1px solid #cbd5e1;
	border-radius: 8px;
	margin-top: 4px;
	max-height: 220px !important;
}

.cp-font-select .multiselect__content {
	background: #eef2f6;
}

.cp-font-select .multiselect__option {
	min-height: 26px;
	padding: 5px 9px;
	line-height: 16px;
	font-size: 11px;
	color: #475569;
}

.cp-font-select .multiselect__option--highlight {
	background: #d8e0ea;
	color: #334155;
}

.cp-font-select .multiselect__option--selected {
	background: #cfd8e3;
	color: #334155;
	font-weight: 600;
}

.cp-font-select .multiselect__option--highlight::after {
	display: none !important;
}

.cp-font-select .multiselect__placeholder {
	color: #64748b;
	margin-bottom: 0;
	padding-top: 0;
	font-size: 11px;
}

.cp-item-card {
	position: relative;
	overflow: visible;
}

.cp-item-remove-btn {
	position: absolute;
	top: 0;
	right: 0;
	transform: translate(40%, -50%);
	border-radius: 50% !important;
	width: 24px;
	min-width: 24px;
	height: 24px;
	min-height: 24px;
	padding: 0;
	line-height: 1;
	font-size: 12px;
	display: inline-flex;
	justify-content: center;
	align-items: center;
	z-index: 2;
	box-shadow: 0 1px 4px rgba(15, 23, 42, 0.25);
	border: 1px solid #fff;
}

.multiselect {
	box-sizing: content-box;
	display: block;
	position: relative;
	width: 100%;
	min-height: 20px;
	text-align: left;
	color: #35495e;
}
.multiselect__single {
	padding-left: 0px;
	margin-bottom: 0px;
}
</style>
